import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";

// Gallery Images
import d from "../images/door.jpeg"
import w from "../images/windoor.jpeg"
import kn from "../images/kitchen.jpeg"
import el from "../images/Ele.jpeg"
import pt from "../images/part.jpeg"
import i1 from "../gallery/1.jpeg";
import i2 from "../gallery/2.jpeg";
import i3 from "../gallery/3.jpeg";
import i4 from "../gallery/4.jpeg";
import i5 from "../gallery/5.jpeg";
import i6 from "../gallery/6.jpeg";
import i7 from "../gallery/7.jpeg";
import i8 from "../gallery/8.jpeg";
import i9 from "../gallery/9.jpeg";
import i10 from "../gallery/10.jpeg";
import i11 from "../gallery/11.jpeg";
import i12 from "../gallery/12.jpeg";
import i13 from "../gallery/13.jpeg";
import i14 from "../gallery/14.jpeg";
import i15 from "../gallery/15.jpeg";
import i16 from "../gallery/16.jpeg";
import i17 from "../gallery/17.jpeg";
import i18 from "../gallery/18.jpeg";
import i19 from "../gallery/19.jpeg";
import i20 from "../gallery/20.jpeg";
import i21 from "../gallery/21.jpeg";
import i22 from "../gallery/22.jpeg";
import i23 from "../gallery/23.jpeg";
import i24 from "../gallery/24.jpeg";
import i25 from "../gallery/25.jpeg";
import i26 from "../gallery/26.jpeg";
import i27 from "../gallery/27.jpeg";
import i28 from "../gallery/28.jpeg";
import i29 from "../gallery/29.jpeg";
import i30 from "../gallery/30.jpeg";
import i31 from "../gallery/31.jpeg";
import i32 from "../gallery/32.jpeg";
import i33 from "../gallery/33.jpeg";
import i34 from "../gallery/34.jpeg";
import i35 from "../gallery/35.jpeg";
import i36 from "../gallery/36.jpeg";
import i37 from "../gallery/37.jpeg";
import i38 from "../gallery/38.jpeg";
import i39 from "../gallery/39.jpeg";
import i40 from "../gallery/40.jpeg";
import i41 from "../gallery/41.jpeg";
import i42 from "../gallery/42.jpeg";
import i43 from "../gallery/43.jpeg";
import i44 from "../gallery/44.jpeg";
import i45 from "../gallery/45.jpeg";
import i46 from "../gallery/46.jpeg";
import i47 from "../gallery/47.jpeg";
import i48 from "../gallery/48.jpeg";
import i49 from "../gallery/49.jpeg";
import i50 from "../gallery/50.jpeg";
import i51 from "../gallery/51.jpeg";
import i52 from "../gallery/52.jpeg";
import i53 from "../gallery/53.jpeg";
import i54 from "../gallery/54.jpeg";

const itemData = [
  { img: w },
  { img: d},
  { img: kn },
  { img: pt },
  { img: el },
  { img: i1 },
  { img: i2 },
  { img: i3 },
  { img: i4 },
  { img: i5 },
  { img: i6 },
  { img: i7 },
  { img: i8 },
  { img: i9 },
  { img: i10 },
  { img: i11 },
  { img: i12 },
  { img: i13 },
  { img: i14 },
  { img: i15 },
  { img: i16 },
  { img: i17 },
  { img: i18 },
  { img: i19 },
  { img: i20 },
  { img: i21 },
  { img: i22 },
  { img: i23 },
  { img: i24 },
  { img: i25 },
  { img: i26 },
  { img: i27 },
  { img: i28 },
  { img: i29 },
  { img: i30 },
  { img: i31 },
  { img: i32 },
  { img: i33 },
  { img: i34 },
  { img: i35 },
  { img: i36 },
  { img: i37 },
  { img: i38 },
  { img: i39 },
  { img: i40 },
  { img: i41 },
  { img: i42 },
  { img: i43 },
  { img: i44 },
  { img: i45 },
  { img: i46 },
  { img: i47 },
  { img: i48 },
  { img: i49 },
  { img: i50 },
  { img: i51 },
  { img: i52 },
  { img: i53 },
  { img: i54 },
];

export default function StandardImageList() {
  return (
    <>
      <h1 className="text-center my-4">Our Work</h1>
      <h4 className="text-center my-4">Built with care, delivered with pride — a few of our works.</h4>

      <ImageList
        sx={{ height: 500, objectFit: "cover" }}
        cols={3}
        rowHeight={164}
      >
        {itemData.map((item, index) => (
          <ImageListItem key={index}>
            <img
              src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
              srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
              alt="Gallery"
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </>
  );
}
